
import * as React from "react"
import { isPwaMode } from "@/utils/pwaUtils";

const MOBILE_BREAKPOINT = 768

/**
 * Hook to detect mobile devices based on screen width and PWA mode
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(false)
  const isPwa = isPwaMode();
  
  React.useEffect(() => {
    const checkMobile = () => {
      // Consider PWA mode always mobile for consistent UI
      const isMobileDevice = isPwa || window.innerWidth < MOBILE_BREAKPOINT;
      
      // Also check for typical mobile user agents
      const userAgentIsMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      
      // Check for standalone mode (PWA)
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      
      setIsMobile(isMobileDevice || userAgentIsMobile || isStandalone);
    };
    
    // Initial check
    checkMobile();
    
    // Listen for window resize events
    window.addEventListener('resize', checkMobile);
    
    // Listen for orientation change
    window.addEventListener('orientationchange', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('orientationchange', checkMobile);
    };
  }, [isPwa]);

  return isMobile;
}

// For compatibility with existing code that might be using useMobile
export const useMobile = useIsMobile;
